angular.module('omega').service('LabelService', function (API_BASE_URL, $rootScope, $http, $q) {

    var cachedPromises = {};

    // returns a promise of the request to get a label from a URI
    this.get = function (uri, lang) {

        lang = typeof lang !== 'undefined' ? lang : $rootScope.lang;

        if (typeof cachedPromises[uri + lang] !== 'undefined') return cachedPromises[uri + lang];

        // Warning : We are building a URL that has its parameters included in a orthodox way. API should accept classic encoded params to be more stable.
        cachedPromises[uri + lang] = $http.get(
            API_BASE_URL + 'URI-to-mainLabel-BlackBox.xqy' + '?uri=' + uri.replace(/\#/g, "%23") + '&lang=' + lang.toLowerCase()
        );

        return cachedPromises[uri + lang];
    };

    this.getCollectionNameFromUri = function (collectionUri) {

        if (typeof $rootScope.searchProfiles === 'undefined') {
            return collectionUri;
        }

        for (var i = 0; i < $rootScope.searchProfiles.length; i++) {

            if ($rootScope.searchProfiles[i].hasOwnProperty('groups')) {
                for (var j = 0; j < $rootScope.searchProfiles[i].groups.length; j++) {
                    if ($rootScope.searchProfiles[i].groups[j].hasOwnProperty('collections')) {
                        for (var k = 0; k < $rootScope.searchProfiles[i].groups[j].collections.length; k++) {
                            if (collectionUri === $rootScope.searchProfiles[i].groups[j].collections[k].uri) {
                                return $rootScope.searchProfiles[i].groups[j].collections[k].label;
                            }
                        }
                    }


                }
            }

        }
        return collectionUri;
    };

    // Returns an array of deferred promises
    this.list = function (uris) {
        var promises = [];

        if (typeof uris !== 'undefined' && uris.length) {
            for (var i = 0; i < uris.length; i++) {
                promises.push(this.get(uris[i]));
            }
        }
        return $q.all(promises);
    }
});
